window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.ActiveKD = function() {
	this.initialize(img.LaptopAssets_ActiveKD);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,393,385);


(lib.BackButtonDisabled = function() {
	this.initialize(img.LaptopAssets_BackButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,26);


(lib.BackButtonHi = function() {
	this.initialize(img.LaptopAssets_BackButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,26);


(lib.BackButtonUp = function() {
	this.initialize(img.LaptopAssets_BackButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,26);


(lib.ChatIcon = function() {
	this.initialize(img.LaptopAssets_ChatIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,114,114);


(lib.ChatNPCBalloon2 = function() {
	this.initialize(img.LaptopAssets_ChatNPCBalloon2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,352,61);


(lib.ChoiceIndicator111 = function() {
	this.initialize(img.LaptopAssets_ChoiceIndicator111);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,4,78);


(lib.CloseButtonDisabled = function() {
	this.initialize(img.LaptopAssets_CloseButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.CloseButtonHi = function() {
	this.initialize(img.LaptopAssets_CloseButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.CloseButtonIcon = function() {
	this.initialize(img.LaptopAssets_CloseButtonIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,17,17);


(lib.CloseButtonUp = function() {
	this.initialize(img.LaptopAssets_CloseButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,19,19);


(lib.DraftBG = function() {
	this.initialize(img.LaptopAssets_DraftBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,57,63);


(lib.EditIconDisabled = function() {
	this.initialize(img.LaptopAssets_EditIconDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,6);


(lib.EditIconUp = function() {
	this.initialize(img.LaptopAssets_EditIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,22,6);


(lib.EmailReceivedBackground = function() {
	this.initialize(img.LaptopAssets_EmailReceivedBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,386,343);


(lib.EmptyThumb = function() {
	this.initialize(img.LaptopAssets_EmptyThumb);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,66,66);


(lib.EmptyThumbBig = function() {
	this.initialize(img.LaptopAssets_EmptyThumbBig);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,80,80);


(lib.FileExplorerNew = function() {
	this.initialize(img.LaptopAssets_FileExplorerNew);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,12,13);


(lib.FolderIconUp = function() {
	this.initialize(img.LaptopAssets_FolderIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,36,33);


(lib.GroupChatNPCBalloon2 = function() {
	this.initialize(img.LaptopAssets_GroupChatNPCBalloon2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,352,101);


(lib.ImageIconUp = function() {
	this.initialize(img.LaptopAssets_ImageIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,36,36);


(lib.LaptopBackArrow = function() {
	this.initialize(img.LaptopAssets_LaptopBackArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,21);


(lib.LaptopBackArrowWhite = function() {
	this.initialize(img.LaptopAssets_LaptopBackArrowWhite);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,18,21);


(lib.LaptopChoiceButtonDisabled = function() {
	this.initialize(img.LaptopAssets_LaptopChoiceButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,857,74);


(lib.LaptopChoiceButtonHi = function() {
	this.initialize(img.LaptopAssets_LaptopChoiceButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,857,74);


(lib.LaptopChoiceButtonUp = function() {
	this.initialize(img.LaptopAssets_LaptopChoiceButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,857,74);


(lib.LaptopDesktop = function() {
	this.initialize(img.LaptopAssets_LaptopDesktop);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1403,802);


(lib.LaptopDraftCounterIcon = function() {
	this.initialize(img.LaptopAssets_LaptopDraftCounterIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,48,33);


(lib.LaptopDraftIcon = function() {
	this.initialize(img.LaptopAssets_LaptopDraftIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,30,30);


(lib.LaptopDropDownArrow = function() {
	this.initialize(img.LaptopAssets_LaptopDropDownArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,26,13);


(lib.LaptopEmailIndicatorButtonBackground = function() {
	this.initialize(img.LaptopAssets_LaptopEmailIndicatorButtonBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,226,24);


(lib.LaptopEmailOptionButton = function() {
	this.initialize(img.LaptopAssets_LaptopEmailOptionButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,884,54);


(lib.LaptopFolderNotification = function() {
	this.initialize(img.LaptopAssets_LaptopFolderNotification);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,8,8);


(lib.LaptopInboxIcon = function() {
	this.initialize(img.LaptopAssets_LaptopInboxIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,29,27);


(lib.LaptopMailIcon = function() {
	this.initialize(img.LaptopAssets_LaptopMailIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,30,23);


(lib.LaptopModalButonUp = function() {
	this.initialize(img.LaptopAssets_LaptopModalButonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,885,55);


(lib.LaptopModalButtonHipngcopy = function() {
	this.initialize(img.LaptopAssets_LaptopModalButtonHipngcopy);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,885,55);


(lib.LaptopSentButtonDisabled = function() {
	this.initialize(img.LaptopAssets_LaptopSentButtonDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,54,54);


(lib.LaptopSentButtonHi = function() {
	this.initialize(img.LaptopAssets_LaptopSentButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,54,54);


(lib.LaptopSentButtonUp = function() {
	this.initialize(img.LaptopAssets_LaptopSentButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,54,54);


(lib.LaptopSentIcon = function() {
	this.initialize(img.LaptopAssets_LaptopSentIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,32,32);


(lib.LaptopSkinBG = function() {
	this.initialize(img.LaptopAssets_LaptopSkinBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.LaptopVinkje = function() {
	this.initialize(img.LaptopAssets_LaptopVinkje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,26,18);


(lib.LaptopVinkjeWhite = function() {
	this.initialize(img.LaptopAssets_LaptopVinkjeWhite);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,26,18);


(lib.MailIcon = function() {
	this.initialize(img.LaptopAssets_MailIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,114,114);


(lib.NewIndicatorLarge = function() {
	this.initialize(img.LaptopAssets_NewIndicatorLarge);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,28,28);


(lib.PdfIconUp = function() {
	this.initialize(img.LaptopAssets_PdfIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,36,36);


(lib.PowerpointIconUp = function() {
	this.initialize(img.LaptopAssets_PowerpointIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,36,36);


(lib.RedPill = function() {
	this.initialize(img.LaptopAssets_RedPill);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,39,28);


(lib.ReplyIcon = function() {
	this.initialize(img.LaptopAssets_ReplyIcon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,25,30);


(lib.SmartphoneCloseButton = function() {
	this.initialize(img.LaptopAssets_SmartphoneCloseButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,77,35);


(lib.Spinner = function() {
	this.initialize(img.LaptopAssets_Spinner);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,42,42);


(lib.SpinnerPanel = function() {
	this.initialize(img.LaptopAssets_SpinnerPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,436,136);


(lib.SpreadsheetIconUp = function() {
	this.initialize(img.LaptopAssets_SpreadsheetIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,36,36);


(lib.WordIconUp = function() {
	this.initialize(img.LaptopAssets_WordIconUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,36,36);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Tween1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ActiveKD();
	this.instance.setTransform(-114,-110,2.0181,2.0183);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-114,-110,793.1,777.1);


(lib.WordIconUpBas = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.WordIconUp();
	this.instance.setTransform(-17,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.WordIconUpBas, new cjs.Rectangle(-17,-15.5,36,36), null);


(lib.vinkjeIconBaseWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LaptopVinkjeWhite();
	this.instance.setTransform(-13,-9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vinkjeIconBaseWhite, new cjs.Rectangle(-13,-9,26,18), null);


(lib.vinkjeIconBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LaptopVinkje();
	this.instance.setTransform(-13,-9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vinkjeIconBase, new cjs.Rectangle(-13,-9,26,18), null);


(lib.SpreadsheetIconUpBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SpreadsheetIconUp();
	this.instance.setTransform(-17,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SpreadsheetIconUpBase, new cjs.Rectangle(-17,-15.5,36,36), null);


(lib.SpinnerBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Spinner();
	this.instance.setTransform(-21,-21);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SpinnerBase, new cjs.Rectangle(-21,-21,42,42), null);


(lib.SmartphoneCloseButon2Base = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SmartphoneCloseButton();
	this.instance.setTransform(-38.5,-17.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmartphoneCloseButon2Base, new cjs.Rectangle(-38.5,-17.5,77,35), null);


(lib.SmallBackButtonBaseWhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LaptopBackArrowWhite();
	this.instance.setTransform(-9,-11);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmallBackButtonBaseWhite, new cjs.Rectangle(-9,-11,18,21), null);


(lib.SmallBackButtonBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LaptopBackArrow();
	this.instance.setTransform(-9,-11);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmallBackButtonBase, new cjs.Rectangle(-9,-11,18,21), null);


(lib.SendButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LaptopSentButtonUp();
	this.instance.setTransform(-27,-27);

	this.instance_1 = new lib.LaptopSentButtonHi();
	this.instance_1.setTransform(-27,-27);

	this.instance_2 = new lib.LaptopSentButtonDisabled();
	this.instance_2.setTransform(-27,-27);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-27,-27,54,54);


(lib.ScrollContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("AgEgEIAJAAIAAAJIgJAAg");
	this.shape.setTransform(0.5,0.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("AgEAFIAAgJIAJAAIAAAJg");
	this.shape_1.setTransform(0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ScrollContainer, new cjs.Rectangle(-1,-1,3,3), null);


(lib.ScreenOverlayBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("Ehthg+pMDbDAAAMAAAB9TMjbDAAAg");
	this.shape.setTransform(700,399.9755);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#67666F").s().p("EhthA+qMAAAh9TMDbDAAAMAAAB9Tg");
	this.shape_1.setTransform(700,399.9755);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ScreenOverlayBase, new cjs.Rectangle(-2,-2,1404,804), null);


(lib.RoundEmpty = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(202,201,204,0.008)").s().p("AjTDUQhYhXAAh9QAAh7BYhYQBYhYB7AAQB8AABYBYQBYBYAAB7QAAB9hYBXQhYBYh8AAQh7AAhYhYg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.RoundEmpty, new cjs.Rectangle(-30,-30,60,60), null);


(lib.ReplyIcon_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ReplyIcon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ReplyIcon_1, new cjs.Rectangle(0,0,25,30), null);


(lib.PowerpointIconUpBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PowerpointIconUp();
	this.instance.setTransform(-17,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PowerpointIconUpBase, new cjs.Rectangle(-17,-15.5,36,36), null);


(lib.PdfIconUpBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.PdfIconUp();
	this.instance.setTransform(-17,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PdfIconUpBase, new cjs.Rectangle(-17,-15.5,36,36), null);


(lib.NewIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"1digit":0,"2digits":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.textField = new cjs.Text("3", "bold 18px 'Open Sans'", "#FFFFFF");
	this.textField.name = "textField";
	this.textField.textAlign = "center";
	this.textField.lineHeight = 27;
	this.textField.lineWidth = 22;
	this.textField.parent = this;
	this.textField.setTransform(0,-13);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1).to({x:-4.05,text:"33"},0).wait(1));

	// Layer_1
	this.instance = new lib.NewIndicatorLarge();
	this.instance.setTransform(-14,-14);

	this.instance_1 = new lib.RedPill();
	this.instance_1.setTransform(-23,-14);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-23,-15,39,30);


(lib.LaptopEmailClientBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1_copy
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EBEAEA").s().p("EhtXA4QMAAAhwfMDavAAAMAAABwfg");
	this.shape.setTransform(50,15);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("EhtXA+gMAAAh8/MDavAAAMAAAB8/g");
	this.shape_1.setTransform(50,-25);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailClientBG, new cjs.Rectangle(-650,-425,1400,800), null);


(lib.ImageIconUpBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ImageIconUp();
	this.instance.setTransform(-17,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ImageIconUpBase, new cjs.Rectangle(-17,-15.5,36,36), null);


(lib.ImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.FileIconUpBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FolderIconUp();
	this.instance.setTransform(-17,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileIconUpBase, new cjs.Rectangle(-17,-15.5,36,33), null);


(lib.FileExplorerBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhtXA+gMAAAh8/MDavAAAMAAAB8/g");
	this.shape.setTransform(50,-25);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileExplorerBG, new cjs.Rectangle(-650,-425,1400,800), null);


(lib.EmptySquare = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.012)").s().p("AjbDcIAAm3IG3AAIAAG3g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmptySquare, new cjs.Rectangle(-22,-22,44,44), null);


(lib.EmptyListButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhQ7AISIAAwjMCh3AAAIAAQjg");
	this.shape.setTransform(518,53);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#EBEAEA").s().p("EhQ7AISIAAwjMCh3AAAIAAQjg");
	this.shape_1.setTransform(518,53);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1036,106);


(lib.EmptyContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.EmailSentTextComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bodyTextField = new cjs.Text("Dear mayor,\n\nLorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam. ", "20px 'Arial'", "#333333");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 25;
	this.bodyTextField.lineWidth = 881;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailSentTextComponentSkin, new cjs.Rectangle(0,0,885.3,122), null);


(lib.EmailReceivedItemImageContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.EmailDraftTextComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bodyTextField = new cjs.Text("Dear mayor,\n\nLorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.", "20px 'Arial'", "#333333");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 25;
	this.bodyTextField.lineWidth = 882;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(2,2);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftTextComponentSkin, new cjs.Rectangle(0,0,886,264), null);


(lib.EditIconUp_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EditIconUp();
	this.instance.setTransform(-11,-3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EditIconUp_1, new cjs.Rectangle(-11,-3,22,6), null);


(lib.EditIconDisabeld = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EditIconDisabled();
	this.instance.setTransform(-11,-3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EditIconDisabeld, new cjs.Rectangle(-11,-3,22,6), null);


(lib.DropDownIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.LaptopDropDownArrow();
	this.instance.setTransform(-13,-7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DropDownIcon, new cjs.Rectangle(-13,-7,26,13), null);


(lib.DragButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AhVDIIAAmPICrAAIAAGPg");
	this.shape.setTransform(-4.4,1,1,1.105);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-13,-21.1,17.2,44.2);


(lib.DraftsIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.textField = new cjs.Text("3", "20px 'Arial'", "#333333");
	this.textField.name = "textField";
	this.textField.textAlign = "center";
	this.textField.lineHeight = 24;
	this.textField.lineWidth = 22;
	this.textField.parent = this;
	this.textField.setTransform(0,-13);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	// Laag_3
	this.instance = new lib.LaptopDraftCounterIcon();
	this.instance.setTransform(-23,-17);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DraftsIndicator, new cjs.Rectangle(-23,-17,48,33.3), null);


(lib.ContentContainer = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0.012)").s().p("AgEAFIAAgJIAJAAIAAAJg");
	this.shape.setTransform(0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ContentContainer, new cjs.Rectangle(0,0,1,1), null);


(lib.CloseButtonBase = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.CloseButtonIcon();
	this.instance.setTransform(-8.5,-8.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.CloseButtonBase, new cjs.Rectangle(-8.5,-8.5,17,17), null);


(lib.ChoiceIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ChoiceIndicator111();
	this.instance.setTransform(-1,-1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChoiceIndicator, new cjs.Rectangle(-1,-1,4,78), null);


(lib.EmailReceivedItemBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EmailReceivedBackground();
	this.instance.setTransform(0,0,2.6528,1.0787);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailReceivedItemBackground, new cjs.Rectangle(0,0,1024,370), null);


(lib.SentButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,selectedUp:4,selectedOver:5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#1E1E28").ss(1,1,1).p("A7vAAMA3fAAA");
	this.shape.setTransform(-20.375,41.05);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(8));

	// selectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 24;
	this.selectedDisabledLabelTextField.lineWidth = 236;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// selectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.lineHeight = 24;
	this.selectedDownLabelTextField.lineWidth = 236;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// selectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.lineHeight = 24;
	this.selectedOverLabelTextField.lineWidth = 236;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// selectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.lineHeight = 24;
	this.selectedUpLabelTextField.lineWidth = 236;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 24;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 24;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 24;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 24;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// icon
	this.instance = new lib.LaptopSentIcon();
	this.instance.setTransform(-177,-6);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(8));

	// bg
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("A+7D6IAAnzMA93AAAIAAHzg");
	this.shape_1.setTransform(-20.774,8.0157,0.8951,1.321);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("A/ED6IAAnzMA+JAAAIAAHzg");
	this.shape_2.setTransform(-19.9909,8.0118,0.8951,1.322);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1}]}).to({state:[{t:this.shape_2,p:{scaleY:1.322,y:8.0118}}]},2).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2,p:{scaleY:1.321,y:8.0157}}]},1).to({state:[{t:this.shape_1}]},2).to({state:[{t:this.shape_2,p:{scaleY:1.321,y:8.0157}}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-199,-25,357.3,67.1);


(lib.EmailBoxSelectionBlurOverlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("Egbzg3sMA3nAAAMAAABvZMg3nAAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(235,234,234,0.749)").s().p("EgbzA3tMAAAhvZMA3nAAAMAAABvZg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailBoxSelectionBlurOverlay, new cjs.Rectangle(-179,-357.5,358,715), null);


(lib.LaptopFrame = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.LaptopSkinBG();
	this.instance.setTransform(-942,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopFrame, new cjs.Rectangle(-942,-540,1920,1080), null);


(lib.LaptopDimensions = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EhtXg/RMDavAAAMAAAB+jMjavAAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("EhtXA/SMAAAh+jMDavAAAMAAAB+jg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopDimensions, new cjs.Rectangle(-701,-406,1402,812), null);


(lib.FileExplorerFileViewerContentDragArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EBEAEA").s().p("EgB3AzpMAAAhnRIDvAAMAAABnRg");
	this.shape.setTransform(-0.3,330.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileExplorerFileViewerContentDragArea, new cjs.Rectangle(-12.3,0,24,661), null);


(lib.NewNotification = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1_copy
	this.instance = new lib.FileExplorerNew();
	this.instance.setTransform(-5,-6);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NewNotification, new cjs.Rectangle(-5,-6,12,13), null);


(lib.NewDocumentNotification = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1_copy
	this.instance = new lib.LaptopFolderNotification();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NewDocumentNotification, new cjs.Rectangle(0,0,8,8), null);


(lib.LaptopEmailContentDragArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EBEAEA").s().p("EgB3A3tMAAAhvZIDvAAMAAABvZg");
	this.shape.setTransform(-0.125,356.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailContentDragArea, new cjs.Rectangle(-12.1,0,24,713), null);


(lib.FileExplorerAppContentDragArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EBEAEA").s().p("EgA7AwmMAAAhhLIB3AAMAAABhLg");
	this.shape.setTransform(0.3118,311,2.002,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileExplorerAppContentDragArea, new cjs.Rectangle(-11.7,0,24,622), null);


(lib.NoPortraitThumbSmall = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EmptyThumb();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NoPortraitThumbSmall, new cjs.Rectangle(0,0,66,66), null);


(lib.NoPortraitThumb = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.EmptyThumbBig();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NoPortraitThumb, new cjs.Rectangle(0,0,80,80), null);


(lib.ChatOtherIndividualMessage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.contentTextField = new cjs.Text("[This text should fill the whole row..................]", "15px 'Arial'");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.lineHeight = 19;
	this.contentTextField.lineWidth = 319;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(24.85,17.5);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get(this.contentTextField).wait(1));

	// bg
	this.instance = new lib.ChatNPCBalloon2();
	this.instance.setTransform(7,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatOtherIndividualMessage, new cjs.Rectangle(-502.5,-405,1401,811), null);


(lib.ChatGroupMessage = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.nameTextField = new cjs.Text("Name", "bold 12px 'Open Sans'");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 18;
	this.nameTextField.lineWidth = 319;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(25,16);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.contentTextField = new cjs.Text("[This text should fill the whole row...................]", "15px 'Arial'");
	this.contentTextField.name = "contentTextField";
	this.contentTextField.lineHeight = 19;
	this.contentTextField.lineWidth = 319;
	this.contentTextField.parent = this;
	this.contentTextField.setTransform(25,36);
ranj.TextOffsetFixer.fix(this.contentTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.contentTextField},{t:this.nameTextField}]}).wait(1));

	// bg
	this.instance = new lib.GroupChatNPCBalloon2();
	this.instance.setTransform(7,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatGroupMessage, new cjs.Rectangle(-502.5,-405,1401,811), null);


(lib.LaptopOverlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.498)").s().p("EhP/AzkMAAAhnHMCf/AAAMAAABnHg");
	this.shape.setTransform(0.0063,0.0201,1.875,1.6364);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopOverlay, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.IndicatorBackgroundButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.instance = new lib.LaptopEmailIndicatorButtonBackground();
	this.instance.setTransform(0,0,1.0044,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,227,24);


(lib.EmailIcon = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"new":0,opened:1,newWithAttachment:2,openedWithAttachment:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Attach
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#9F9F9F").s().p("AgaA6QgBAAAAgBQAAAAAAgBQAAAAAAgBQAAAAABgBIBQhKQAEgEgBgFQgBgHgEgEIgGgHQgFgFgGgBQgFgBgEADIhRBMQgCACAAAEQABAEADADIADAEQAIAHAGgFIA9g4IgBAAQADgDgDgFQgFgFgDADIgpAmQgBABAAAAQAAAAgBAAQAAAAgBAAQgBgBAAAAQgBgBAAAAQAAgBAAAAQAAgBAAgBQAAAAABgBIAoglQADgDAFABQAFABADADQAJAJgHAHIg9A5QgDADgHAAQgGgCgFgFIgDgEQgFgFgBgEIAAgDQgBgGAEgEIBRhKQAEgFAJABQAIACAGAGIAHAIQAGAGABAIQABAJgFAEIhRBLIgCABIgCgCg");
	this.shape.setTransform(16.0745,9.6727);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2).to({_off:false},0).wait(2));

	// Layer_1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AhbA7IAAh1IBcBcIBbhcIAAB1g");
	this.shape_1.setTransform(9.2,7.05);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AhPgnICfAAIhQBPg");
	this.shape_2.setTransform(9.225,4);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("rgba(255,255,255,0.4)").s().p("AhbBBIAAh1IBcBbIBbhbIAAB1gAhPhAICgAAIhQBPg");
	this.shape_3.setTransform(9.2,6.475);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1}]}).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_2},{t:this.shape_1}]},1).to({state:[{t:this.shape_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,22.4,15.7);


(lib.NewKeyDecisionFound = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Tween1("synched",0);
	this.instance.setTransform(34.9,34.75,0.1236,0.1248,0,0,0,282.4,278.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({regX:282.6,scaleX:0.1255,scaleY:0.1267,x:34.95},0).wait(1).to({scaleX:0.1296,scaleY:0.1309},0).wait(1).to({scaleX:0.1364,scaleY:0.1377},0).wait(1).to({scaleX:0.1461,scaleY:0.1475},0).wait(1).to({scaleX:0.1589,scaleY:0.1604},0).wait(1).to({scaleX:0.175,scaleY:0.1766},0).wait(1).to({scaleX:0.1939,scaleY:0.1957},0).wait(1).to({scaleX:0.2151,scaleY:0.2171,y:34.7},0).wait(1).to({scaleX:0.2373,scaleY:0.2395,y:34.75},0).wait(1).to({scaleX:0.2591,scaleY:0.2615,y:34.7},0).wait(1).to({scaleX:0.2791,scaleY:0.2818},0).wait(1).to({scaleX:0.2967,scaleY:0.2995},0).wait(1).to({scaleX:0.3113,scaleY:0.3143},0).wait(1).to({scaleX:0.323,scaleY:0.326},0).wait(1).to({scaleX:0.3319,scaleY:0.335},0).wait(1).to({scaleX:0.3383,scaleY:0.3414},0).wait(1).to({scaleX:0.3423,scaleY:0.3455,x:34.9},0).wait(1).to({regX:281.8,regY:278.1,scaleX:0.3444,scaleY:0.3476,x:34.8,y:34.65},0).wait(1).to({regX:282.6,regY:278.5,scaleX:0.3438,scaleY:0.3471,x:35.1,y:34.85},0).wait(1).to({scaleX:0.3427,scaleY:0.3459},0).wait(1).to({scaleX:0.341,scaleY:0.3442},0).wait(1).to({scaleX:0.3386,scaleY:0.3417,y:34.8},0).wait(1).to({scaleX:0.3354,scaleY:0.3386,y:34.85},0).wait(1).to({scaleX:0.3315,scaleY:0.3346},0).wait(1).to({scaleX:0.3268,scaleY:0.3299,y:34.8},0).wait(1).to({scaleX:0.3213,scaleY:0.3243},0).wait(1).to({scaleX:0.3149,scaleY:0.3179,y:34.85},0).wait(1).to({scaleX:0.3079,scaleY:0.3108,x:35.05,y:34.8},0).wait(1).to({scaleX:0.3003,scaleY:0.3031},0).wait(1).to({scaleX:0.2922,scaleY:0.2949,x:35.1},0).wait(1).to({scaleX:0.284,scaleY:0.2867,x:35.05},0).wait(1).to({scaleX:0.276,scaleY:0.2785},0).wait(1).to({scaleX:0.2682,scaleY:0.2707},0).wait(1).to({scaleX:0.261,scaleY:0.2635,x:35,y:34.75},0).wait(1).to({scaleX:0.2545,scaleY:0.2569,y:34.8},0).wait(1).to({scaleX:0.2487,scaleY:0.251,x:35.05},0).wait(1).to({scaleX:0.2436,scaleY:0.2459,x:35},0).wait(1).to({scaleX:0.2394,scaleY:0.2416,y:34.75},0).wait(1).to({scaleX:0.2358,scaleY:0.238,x:35.05},0).wait(1).to({scaleX:0.2329,scaleY:0.235,x:35},0).wait(1).to({scaleX:0.2306,scaleY:0.2328},0).wait(1).to({scaleX:0.2289,scaleY:0.2311,y:34.8},0).wait(1).to({scaleX:0.2278,scaleY:0.2299},0).wait(1).to({regX:281.8,regY:277.9,scaleX:0.2271,scaleY:0.2292,x:34.8,y:34.65},0).wait(1).to({regX:282.6,regY:278.5,scaleX:0.2277,scaleY:0.2298,x:35,y:34.8},0).wait(1).to({scaleX:0.229,scaleY:0.2311},0).wait(1).to({scaleX:0.231,scaleY:0.2331,x:35.05,y:34.85},0).wait(1).to({scaleX:0.2339,scaleY:0.2361},0).wait(1).to({scaleX:0.2377,scaleY:0.2399,x:35,y:34.8},0).wait(1).to({scaleX:0.2425,scaleY:0.2447},0).wait(1).to({scaleX:0.2482,scaleY:0.2505,x:35.05},0).wait(1).to({scaleX:0.2546,scaleY:0.257},0).wait(1).to({scaleX:0.2616,scaleY:0.264},0).wait(1).to({scaleX:0.2686,scaleY:0.2711,y:34.85},0).wait(1).to({scaleX:0.2753,scaleY:0.2778,y:34.8},0).wait(1).to({scaleX:0.2813,scaleY:0.2839,y:34.85},0).wait(1).to({scaleX:0.2866,scaleY:0.2892,x:35.1},0).wait(1).to({scaleX:0.2909,scaleY:0.2936,x:35.05},0).wait(1).to({scaleX:0.2944,scaleY:0.2972,x:35.1},0).wait(1).to({scaleX:0.297,scaleY:0.2998},0).wait(1).to({scaleX:0.299,scaleY:0.3018},0).wait(1).to({scaleX:0.3002,scaleY:0.303},0).wait(1).to({regX:281.9,regY:277.8,scaleX:0.3008,scaleY:0.3036,x:34.8,y:34.65},0).wait(1).to({regX:282.6,regY:278.5,scaleX:0.3005,scaleY:0.3033,x:35,y:34.85},0).wait(1).to({scaleX:0.2998,scaleY:0.3026,x:35.05,y:34.9},0).wait(1).to({scaleX:0.2988,scaleY:0.3016},0).wait(1).to({scaleX:0.2974,scaleY:0.3002},0).wait(1).to({scaleX:0.2956,scaleY:0.2984},0).wait(1).to({scaleX:0.2933,scaleY:0.2961},0).wait(1).to({scaleX:0.2906,scaleY:0.2933,x:35},0).wait(1).to({scaleX:0.2874,scaleY:0.2901},0).wait(1).to({scaleX:0.2837,scaleY:0.2863},0).wait(1).to({scaleX:0.2796,scaleY:0.2822},0).wait(1).to({scaleX:0.2751,scaleY:0.2776,x:35.05,y:34.85},0).wait(1).to({scaleX:0.2703,scaleY:0.2728,y:34.9},0).wait(1).to({scaleX:0.2654,scaleY:0.2678,x:35,y:34.85},0).wait(1).to({scaleX:0.2604,scaleY:0.2629},0).wait(1).to({scaleX:0.2556,scaleY:0.258},0).wait(1).to({scaleX:0.2511,scaleY:0.2534},0).wait(1).to({scaleX:0.2469,scaleY:0.2492},0).wait(1).to({scaleX:0.2431,scaleY:0.2453},0).wait(1).to({scaleX:0.2397,scaleY:0.2419},0).wait(1).to({scaleX:0.2368,scaleY:0.239},0).wait(1).to({scaleX:0.2343,scaleY:0.2365},0).wait(1).to({scaleX:0.2322,scaleY:0.2344,x:34.95},0).wait(1).to({scaleX:0.2305,scaleY:0.2327,x:35},0).wait(1).to({scaleX:0.2292,scaleY:0.2313,x:34.95,y:34.8},0).wait(1).to({scaleX:0.2282,scaleY:0.2303,x:35,y:34.85},0).wait(1).to({scaleX:0.2275,scaleY:0.2296},0).wait(1).to({regX:281.8,regY:277.9,scaleX:0.2271,scaleY:0.2292,x:34.8,y:34.65},0).wait(1).to({regX:282.6,regY:278.5,scaleX:0.2278,scaleY:0.2299,x:35.05,y:34.85},0).wait(1).to({scaleX:0.2294,scaleY:0.2315,x:35,y:34.8},0).wait(1).to({scaleX:0.2319,scaleY:0.2341,x:35.05,y:34.85},0).wait(1).to({scaleX:0.2356,scaleY:0.2377,x:35,y:34.8},0).wait(1).to({scaleX:0.2404,scaleY:0.2426,x:35.05},0).wait(1).to({scaleX:0.2464,scaleY:0.2487},0).wait(1).to({scaleX:0.2534,scaleY:0.2558,x:35,y:34.85},0).wait(1).to({scaleX:0.2611,scaleY:0.2636,x:35.05},0).wait(1).to({scaleX:0.269,scaleY:0.2715},0).wait(1).to({scaleX:0.2764,scaleY:0.279},0).wait(1).to({scaleX:0.2829,scaleY:0.2856},0).wait(1).to({scaleX:0.2885,scaleY:0.2912},0).wait(1).to({scaleX:0.2929,scaleY:0.2956},0).wait(1).to({scaleX:0.2962,scaleY:0.299},0).wait(1).to({scaleX:0.2986,scaleY:0.3014,x:35.1,y:34.9},0).wait(1).to({scaleX:0.3001,scaleY:0.3029,y:34.85},0).wait(1).to({regX:281.9,regY:277.8,scaleX:0.3008,scaleY:0.3036,x:34.8,y:34.65},0).wait(1).to({regX:282.6,regY:278.5,scaleX:0.3002,scaleY:0.303,x:35,y:34.85,alpha:0.9641},0).wait(1).to({scaleX:0.299,scaleY:0.3018,y:34.8,alpha:0.9282},0).wait(1).to({scaleX:0.2971,scaleY:0.2999,x:34.95,y:34.75,alpha:0.8924},0).wait(1).to({scaleX:0.2945,scaleY:0.2972,y:34.7,alpha:0.8565},0).wait(1).to({scaleX:0.2912,scaleY:0.2938,x:34.9,alpha:0.8206},0).wait(1).to({scaleX:0.287,scaleY:0.2895,x:34.85,alpha:0.7847},0).wait(1).to({scaleX:0.2819,scaleY:0.2844,y:34.6,alpha:0.7488},0).wait(1).to({scaleX:0.276,scaleY:0.2783,x:34.75,y:34.55,alpha:0.713},0).wait(1).to({scaleX:0.2692,scaleY:0.2714,alpha:0.6771},0).wait(1).to({scaleX:0.2616,scaleY:0.2636,x:34.7,y:34.45,alpha:0.6412},0).wait(1).to({scaleX:0.2533,scaleY:0.2552,x:34.65,alpha:0.6053},0).wait(1).to({scaleX:0.2445,scaleY:0.2462,x:34.6,y:34.4,alpha:0.5694},0).wait(1).to({scaleX:0.2354,scaleY:0.2369,y:34.35,alpha:0.5336},0).wait(1).to({scaleX:0.2263,scaleY:0.2276,x:34.55,alpha:0.4977},0).wait(1).to({scaleX:0.2175,scaleY:0.2185,x:34.5,y:34.25,alpha:0.4618},0).wait(1).to({scaleX:0.2091,scaleY:0.21,y:34.2,alpha:0.4259},0).wait(1).to({scaleX:0.2013,scaleY:0.2021,x:34.45,y:34.15,alpha:0.39},0).wait(1).to({scaleX:0.1943,scaleY:0.1949,x:34.4,alpha:0.3542},0).wait(1).to({scaleX:0.1881,scaleY:0.1885,x:34.35,y:34.1,alpha:0.3183},0).wait(1).to({scaleX:0.1827,scaleY:0.183,x:34.3,y:34.05,alpha:0.2824},0).wait(1).to({scaleX:0.1781,scaleY:0.1784,x:34.25,y:34,alpha:0.2465},0).wait(1).to({scaleX:0.1742,scaleY:0.1744,alpha:0.2106},0).wait(1).to({scaleX:0.1711,scaleY:0.1713,x:34.2,y:33.95,alpha:0.1748},0).wait(1).to({scaleX:0.1687,scaleY:0.1688,x:34.15,y:33.9,alpha:0.1389},0).wait(1).to({scaleX:0.1669,scaleY:0.1669,alpha:0.103},0).wait(1).to({scaleX:0.1656,scaleY:0.1656,x:34.1,y:33.85,alpha:0.0671},0).wait(1).to({regY:278.3,scaleX:0.1649,scaleY:0.1649,x:33.95,y:33.65,alpha:0.0313},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-101.5,-100.2,273.2,270.1);


(lib.LaptopEmailDraftOptionOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textField
	this.pickAnswerTextField = new cjs.Text("Pick an answer", "bold 20px 'Open Sans'", "#FFFFFF");
	this.pickAnswerTextField.name = "pickAnswerTextField";
	this.pickAnswerTextField.lineHeight = 33;
	this.pickAnswerTextField.lineWidth = 225;
	this.pickAnswerTextField.parent = this;
	this.pickAnswerTextField.setTransform(-250.55,-72);
ranj.TextOffsetFixer.fix(this.pickAnswerTextField);

	this.timeline.addTween(cjs.Tween.get(this.pickAnswerTextField).wait(1));

	// container
	this.container = new lib.EmptyContainer();
	this.container.name = "container";
	this.container.setTransform(158.5,0);

	this.timeline.addTween(cjs.Tween.get(this.container).wait(1));

	// overlay
	this.overlay = new lib.ScreenOverlayBase();
	this.overlay.name = "overlay";
	this.overlay.setTransform(-700,-400);
	this.overlay.alpha = 0.8008;

	this.timeline.addTween(cjs.Tween.get(this.overlay).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailDraftOptionOverlaySkin, new cjs.Rectangle(-701.5,-401.5,1403,803), null);


(lib.TopBarCloseWindowButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.EmptySquare();
	this.hitArea.name = "hitArea";

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_2_copy
	this.instance = new lib.CloseButtonUp();
	this.instance.setTransform(-10,-10);

	this.instance_1 = new lib.CloseButtonHi();
	this.instance_1.setTransform(-8,-8,0.8235,0.8235);

	this.instance_2 = new lib.CloseButtonDisabled();
	this.instance_2.setTransform(-10,-10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.TopBarBackButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.EmptySquare();
	this.hitArea.name = "hitArea";

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_4_copy
	this.instance = new lib.BackButtonUp();
	this.instance.setTransform(-11,-13);

	this.instance_1 = new lib.BackButtonHi();
	this.instance_1.setTransform(-9,-11,0.8325,0.8333);

	this.instance_2 = new lib.BackButtonDisabled();
	this.instance_2.setTransform(-11,-13);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.Spinner_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SpinnerBase();

	this.timeline.addTween(cjs.Tween.get(this.instance).to({rotation:119.9999},17).to({rotation:240.0001},18).to({rotation:360},18).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-29.7,-29.7,59.4,59.4);


(lib.SmarthphoneCloseButtonAnim = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.SmartphoneCloseButon2Base();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SmarthphoneCloseButtonAnim, new cjs.Rectangle(-38.5,-17.5,77,35), null);


(lib.LoadingIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// loadingTextField
	this.loadingTextField = new cjs.Text("Loading...", "18px 'Arial'", "#67666F");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.lineHeight = 20;
	this.loadingTextField.lineWidth = 229;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(-64,-12.95);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.timeline.addTween(cjs.Tween.get(this.loadingTextField).wait(1));

	// spinner
	this.spinner = new lib.Spinner_1();
	this.spinner.name = "spinner";
	this.spinner.setTransform(-151,0);

	this.timeline.addTween(cjs.Tween.get(this.spinner).wait(1));

	// bg
	this.instance = new lib.SpinnerPanel();
	this.instance.setTransform(-218,-68);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingIndicator, new cjs.Rectangle(-218,-68,436,136), null);


(lib.EmailDraftSendComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// sentButton
	this.sentButton = new lib.SendButton();
	this.sentButton.name = "sentButton";
	this.sentButton.setTransform(934,22.5);

	this.timeline.addTween(cjs.Tween.get(this.sentButton).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftSendComponentSkin, new cjs.Rectangle(907,-4.5,54,54), null);


(lib.TopBarCloseWindowButton_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea_1 = new lib.EmptySquare();
	this.hitArea_1.name = "hitArea_1";

	this.timeline.addTween(cjs.Tween.get(this.hitArea_1).wait(4));

	// Layer_2
	this.instance_3 = new lib.CloseButtonBase();
	this.instance_3.setTransform(0.5,0.5);
	var instance_3Filter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.instance_3.filters = [instance_3Filter_1];
	this.instance_3.cache(-10,-10,21,21);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(2).to({scaleX:0.8235,scaleY:0.8235,x:0.4,y:0.4},0).wait(1).to({scaleX:1,scaleY:1,x:0.5,y:0.5},0).wait(1));
	this.timeline.addTween(cjs.Tween.get(instance_3Filter_1).wait(2).to(new cjs.ColorFilter(0,0,0,1,103,102,111,0), 0).wait(1).to(new cjs.ColorFilter(0,0,0,1,235,234,234,0), 0).wait(1));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.instance_3, startFrame:2, endFrame:2, x:-10, y:-10, w:21, h:21});
	this.filterCacheList.push({instance: this.instance_3, startFrame:0, endFrame:0, x:-10, y:-10, w:21, h:21});
	this.filterCacheList.push({instance: this.instance_3, startFrame:3, endFrame:3, x:-10, y:-10, w:21, h:21});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22,-22,44,44);


(lib.FileButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.NewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(61,-39);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(1));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Files", "bold 21px 'Open Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 31;
	this.upLabelTextField.lineWidth = 76;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.5,60.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(1));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Files", "bold 21px 'Open Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 31;
	this.overLabelTextField.lineWidth = 76;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.5,60.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(1));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Files", "bold 21px 'Open Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 31;
	this.downLabelTextField.lineWidth = 76;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.5,60.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(1));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Files", "bold 21px 'Open Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 31;
	this.disabledLabelTextField.lineWidth = 76;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.5,60.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(1));

	// button
	this.instance = new lib.ChatIcon();
	this.instance.setTransform(-57,-57,1,1,-0.0044);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileButton, new cjs.Rectangle(-57,-57,132,150.2), null);


(lib.EmailButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.NewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(61,-39);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(1));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Your email", "bold 21px 'Open Sans'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 24;
	this.upLabelTextField.lineWidth = 76;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-0.5,60.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(1));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Your email", "bold 21px 'Open Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 24;
	this.overLabelTextField.lineWidth = 76;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-0.5,60.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(1));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Your email", "bold 21px 'Open Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 24;
	this.downLabelTextField.lineWidth = 76;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-0.5,60.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(1));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Your email", "bold 21px 'Open Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 24;
	this.disabledLabelTextField.lineWidth = 76;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-0.5,60.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(1));

	// button
	this.instance = new lib.MailIcon();
	this.instance.setTransform(-57,-57);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailButton, new cjs.Rectangle(-57,-57,132,179.1), null);


(lib.EmailBoxButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selectedUp":4,"selectedOver":5,"selectedDown":6,"selectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#1E1E28").ss(1,1,1).p("A7vAAMA3fAAA");
	this.shape.setTransform(-20.375,41.05);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(8));

	// selectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 24;
	this.selectedDisabledLabelTextField.lineWidth = 236;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// selectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.lineHeight = 24;
	this.selectedDownLabelTextField.lineWidth = 236;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// selectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.lineHeight = 24;
	this.selectedOverLabelTextField.lineWidth = 236;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// selectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.lineHeight = 24;
	this.selectedUpLabelTextField.lineWidth = 236;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 24;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 24;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 24;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 24;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// indicator
	this.indicator = new lib.NewIndicator();
	this.indicator.name = "indicator";
	this.indicator.setTransform(127,7.5);

	this.timeline.addTween(cjs.Tween.get(this.indicator).wait(8));

	// icon
	this.instance = new lib.LaptopInboxIcon();
	this.instance.setTransform(-175.5,-3.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(8));

	// bg
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("A/ED8IAAn3MA+JAAAIAAH3g");
	this.shape_1.setTransform(-19.9909,8.2469,0.8951,1.321);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("A/ED6IAAnzMA+JAAAIAAHzg");
	this.shape_2.setTransform(-19.9909,8.0118,0.8951,1.322);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("rgba(255,255,255,0.008)").s().p("A/ED6IAAnzMA+JAAAIAAHzg");
	this.shape_3.setTransform(-19.9909,8.0118,0.8951,1.322);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1}]}).to({state:[{t:this.shape_2}]},2).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},2).to({state:[{t:this.shape_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-199,-25,357.3,67.1);


(lib.DraftsButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,"selectedUp":4,"selectedOver":5,"selectedDown":6,"selectedDisabled":7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#1E1E28").ss(1,1,1).p("A7vAAMA3fAAA");
	this.shape.setTransform(-20.375,41.05);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(8));

	// selectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 24;
	this.selectedDisabledLabelTextField.lineWidth = 236;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// selectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.lineHeight = 24;
	this.selectedDownLabelTextField.lineWidth = 236;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// selectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.lineHeight = 24;
	this.selectedOverLabelTextField.lineWidth = 236;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// selectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.lineHeight = 24;
	this.selectedUpLabelTextField.lineWidth = 236;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 24;
	this.disabledLabelTextField.lineWidth = 236;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 24;
	this.downLabelTextField.lineWidth = 236;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 24;
	this.overLabelTextField.lineWidth = 236;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Button text", "20px 'Arial'", "#1E1E28");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 24;
	this.upLabelTextField.lineWidth = 236;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-120.95,-5.7);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// indicator
	this.indicator = new lib.DraftsIndicator();
	this.indicator.name = "indicator";
	this.indicator.setTransform(120.15,6);

	this.timeline.addTween(cjs.Tween.get(this.indicator).wait(8));

	// icon
	this.instance = new lib.LaptopDraftIcon();
	this.instance.setTransform(-174,-9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(8));

	// bg
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("A+7D6IAAnzMA93AAAIAAHzg");
	this.shape_1.setTransform(-20.774,8.0157,0.8951,1.321);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("A+7D6IAAnzMA93AAAIAAHzg");
	this.shape_2.setTransform(-20.774,8.0157,0.8951,1.321);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("A/ED6IAAnzMA+JAAAIAAHzg");
	this.shape_3.setTransform(-19.9909,8.0157,0.8951,1.321);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1}]}).to({state:[{t:this.shape_2}]},2).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_1}]},2).to({state:[{t:this.shape_3}]},1).wait(1));

	// line
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f().s("#1E1E28").ss(1,1,1).p("A7vAAMA3fAAA");
	this.shape_4.setTransform(-20.375,41.05);

	this.timeline.addTween(cjs.Tween.get(this.shape_4).to({_off:true},4).wait(4));

	// bg
	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("rgba(255,255,255,0.008)").s().p("A+7D6IAAnzMA93AAAIAAHzg");
	this.shape_5.setTransform(-20.774,8.0157,0.8951,1.321);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("A/ED6IAAnzMA+JAAAIAAHzg");
	this.shape_6.setTransform(-19.9909,8.0157,0.8951,1.321);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5}]}).to({state:[{t:this.shape_6}]},2).to({state:[{t:this.shape_5}]},1).to({state:[]},1).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-199,-25,357.3,67.1);


(lib.SmartphoneCloseButton_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hitArea
	this.hitArea = new lib.RoundEmpty();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(0,0,1.2667,0.9);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// Layer_3
	this.instance = new lib.SmarthphoneCloseButtonAnim();
	this.instance.setTransform(-0.5,-4.5);

	this.instance_1 = new lib.SmartphoneCloseButon2Base();
	this.instance_1.setTransform(-0.5,-4.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1,p:{y:-4.5}}]},1).to({state:[{t:this.instance_1,p:{y:0.5}}]},1).to({state:[]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-53,-51,113,113);


(lib.FileExplorerViewerScrollPane = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// itemContainer
	this.itemContainer = new lib.ScrollContainer();
	this.itemContainer.name = "itemContainer";
	this.itemContainer.setTransform(0.5,0.5,1,1,0,0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.itemContainer).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("Ehscgz3MDY5AAAMAAABnvMjY5AAAg");
	this.shape.setTransform(694.0043,332);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CAC9CC").s().p("EhsbAz4MAAAhnvMDY3AAAMAAABnvg");
	this.shape_1.setTransform(694.0043,332);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileExplorerViewerScrollPane, new cjs.Rectangle(-1,-1,1390,666), null);


(lib.FileExplorerViewerScrollBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// knob
	this.dragButton = new lib.DragButton();
	this.dragButton.name = "dragButton";
	this.dragButton.setTransform(4.5,22);

	this.timeline.addTween(cjs.Tween.get(this.dragButton).wait(1));

	// dragArea
	this.dragArea = new lib.FileExplorerFileViewerContentDragArea();
	this.dragArea.name = "dragArea";
	this.dragArea.setTransform(0,0,1,1.006);

	this.timeline.addTween(cjs.Tween.get(this.dragArea).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileExplorerViewerScrollBar, new cjs.Rectangle(-12.3,0,24,665), null);


(lib.LaptopEmailScrollBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// knob
	this.dragButton = new lib.DragButton();
	this.dragButton.name = "dragButton";
	this.dragButton.setTransform(4.25,21.5);

	this.timeline.addTween(cjs.Tween.get(this.dragButton).wait(1));

	// dragArea
	this.dragArea = new lib.LaptopEmailContentDragArea();
	this.dragArea.name = "dragArea";

	this.timeline.addTween(cjs.Tween.get(this.dragArea).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailScrollBar, new cjs.Rectangle(-12.1,0,24,713), null);


(lib.FileExplorerItem = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop();
	}
	this.frame_1 = function() {
		this.stop();
	}
	this.frame_2 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1).call(this.frame_2).wait(2));

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#EBEAEA").ss(1,1,1).p("Ehl8AAAMDL5AAA");
	this.shape.setTransform(692,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(4));

	// Notification
	this.newNotification = new lib.NewNotification();
	this.newNotification.name = "newNotification";
	this.newNotification.setTransform(49,34,0.9,0.9);

	this.timeline.addTween(cjs.Tween.get(this.newNotification).wait(4));

	// up
	this.upLabelTextField = new cjs.Text("Client Data and Admin", "18px 'Arial'", "#67666F");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 20;
	this.upLabelTextField.lineWidth = 992;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(129,20);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// over
	this.overLabelTextField = new cjs.Text("Client Data and Admin", "18px 'Arial'", "#67666F");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 20;
	this.overLabelTextField.lineWidth = 992;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(129,20);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// down
	this.downLabelTextField = new cjs.Text("Client Data and Admin", "18px 'Arial'", "#67666F");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 20;
	this.downLabelTextField.lineWidth = 992;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(129,20);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// disabled
	this.disabledLabelTextField = new cjs.Text("Client Data and Admin", "18px 'Arial'", "#67666F");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 20;
	this.disabledLabelTextField.lineWidth = 992;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(129,20);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// imageIcon
	this.imageIcon = new lib.ImageIconUpBase();
	this.imageIcon.name = "imageIcon";
	this.imageIcon.setTransform(90,31.75);

	this.timeline.addTween(cjs.Tween.get(this.imageIcon).wait(4));

	// pdfIcon
	this.pdfIcon = new lib.PdfIconUpBase();
	this.pdfIcon.name = "pdfIcon";
	this.pdfIcon.setTransform(90,31.75);

	this.timeline.addTween(cjs.Tween.get(this.pdfIcon).wait(4));

	// spreadsheetIcon
	this.spreadsheetIcon = new lib.SpreadsheetIconUpBase();
	this.spreadsheetIcon.name = "spreadsheetIcon";
	this.spreadsheetIcon.setTransform(90,31.75);

	this.timeline.addTween(cjs.Tween.get(this.spreadsheetIcon).wait(4));

	// slidesIcon
	this.slidesIcon = new lib.PowerpointIconUpBase();
	this.slidesIcon.name = "slidesIcon";
	this.slidesIcon.setTransform(90,31.75);

	this.timeline.addTween(cjs.Tween.get(this.slidesIcon).wait(4));

	// wordIcon
	this.documentIcon = new lib.WordIconUpBas();
	this.documentIcon.name = "documentIcon";
	this.documentIcon.setTransform(90,31.75);

	this.timeline.addTween(cjs.Tween.get(this.documentIcon).wait(4));

	// directoryIcon
	this.directoryIcon = new lib.FileIconUpBase();
	this.directoryIcon.name = "directoryIcon";
	this.directoryIcon.setTransform(90,31.75);

	this.timeline.addTween(cjs.Tween.get(this.directoryIcon).wait(4));

	// hitArea
	this.hitArea = new lib.EmptySquare();
	this.hitArea.name = "hitArea";
	this.hitArea.setTransform(691.45,32,31.4308,1.4543);

	this.timeline.addTween(cjs.Tween.get(this.hitArea).wait(4));

	// bg
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#EBEAEA").s().p("EhsCAFAIAAp/MDYFAAAIAAJ/g");
	this.shape_1.setTransform(691.5,32);
	this.shape_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1).to({_off:false},0).to({_off:true},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-1,1383,65);


(lib.FileExplorerAppScrollPane = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// itemContainer
	this.itemContainer = new lib.ScrollContainer();
	this.itemContainer.name = "itemContainer";
	this.itemContainer.setTransform(0.5,0.5,1,1,0,0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.itemContainer).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EhsbgwbMDY3AAAMAAABg3MjY3AAAg");
	this.shape.setTransform(694,310.0097);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(255,255,255,0.008)").s().p("EhsbAwcMAAAhg3MDY3AAAMAAABg3g");
	this.shape_1.setTransform(694,310.0097);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileExplorerAppScrollPane, new cjs.Rectangle(-1,-1,1390,622), null);


(lib.FileExplorerAppScrollBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = false; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// knob
	this.dragButton = new lib.DragButton();
	this.dragButton.name = "dragButton";
	this.dragButton.setTransform(4.8,21.5);

	this.timeline.addTween(cjs.Tween.get(this.dragButton).wait(1));

	// dragArea
	this.dragArea = new lib.FileExplorerAppContentDragArea();
	this.dragArea.name = "dragArea";

	this.timeline.addTween(cjs.Tween.get(this.dragArea).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileExplorerAppScrollBar, new cjs.Rectangle(-11.7,0,24,622), null);


(lib.EmailSentPlayerTextSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.indentLine = new lib.ChoiceIndicator();
	this.indentLine.name = "indentLine";
	this.indentLine.setTransform(1,7);
	var indentLineFilter_1 = new cjs.ColorFilter(0,0,0,1,85,164,200,0);
	this.indentLine.filters = [indentLineFilter_1];
	this.indentLine.cache(-3,-3,8,82);

	this.timeline.addTween(cjs.Tween.get(this.indentLine).wait(1));
	this.timeline.addTween(cjs.Tween.get(indentLineFilter_1).wait(1));

	// disabledLabelTextField
	this.textField = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut.", "italic 20px 'Open Sans'", "#333333");
	this.textField.name = "textField";
	this.textField.lineHeight = 29;
	this.textField.lineWidth = 862;
	this.textField.parent = this;
	this.textField.setTransform(19.55,2);
ranj.TextOffsetFixer.fix(this.textField);

	this.timeline.addTween(cjs.Tween.get(this.textField).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailSentPlayerTextSkin, new cjs.Rectangle(0,0,883.3,94.6), null);


(lib.EmailReceivedItemSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// nameTextField
	this.subjectTextField = new cjs.Text("Meeting Lorem Ipsum", "bold 17px 'Open Sans'", "#333333");
	this.subjectTextField.name = "subjectTextField";
	this.subjectTextField.lineHeight = 25;
	this.subjectTextField.lineWidth = 763;
	this.subjectTextField.parent = this;
	this.subjectTextField.setTransform(166.75,74);
ranj.TextOffsetFixer.fix(this.subjectTextField);

	this.subjectLabelTextField = new cjs.Text("Subject:", "17px 'Arial'", "#333333");
	this.subjectLabelTextField.name = "subjectLabelTextField";
	this.subjectLabelTextField.lineHeight = 21;
	this.subjectLabelTextField.lineWidth = 64;
	this.subjectLabelTextField.parent = this;
	this.subjectLabelTextField.setTransform(102,74.05);
ranj.TextOffsetFixer.fix(this.subjectLabelTextField);

	this.toTextField = new cjs.Text("You", "bold 17px 'Open Sans'", "#333333");
	this.toTextField.name = "toTextField";
	this.toTextField.lineHeight = 25;
	this.toTextField.lineWidth = 799;
	this.toTextField.parent = this;
	this.toTextField.setTransform(130.8,52);
ranj.TextOffsetFixer.fix(this.toTextField);

	this.toLabelTextField = new cjs.Text("To:", "17px 'Arial'", "#333333");
	this.toLabelTextField.name = "toLabelTextField";
	this.toLabelTextField.lineHeight = 21;
	this.toLabelTextField.lineWidth = 26;
	this.toLabelTextField.parent = this;
	this.toLabelTextField.setTransform(102,52);
ranj.TextOffsetFixer.fix(this.toLabelTextField);

	this.nameTextField = new cjs.Text("John Doe", "bold 21px 'Open Sans'", "#55A4C8");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 31;
	this.nameTextField.lineWidth = 833;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(101.9,20);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nameTextField},{t:this.toLabelTextField},{t:this.toTextField},{t:this.subjectLabelTextField},{t:this.subjectTextField}]}).wait(1));

	// bodyTextField
	this.bodyTextField = new cjs.Text("Dear mayor,\n\nLorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam. \n\nKind regards,\nJohn Doe", "20px 'Arial'", "#333333");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 25;
	this.bodyTextField.lineWidth = 882;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(64,132);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	// imageContainer
	this.imageContainer = new lib.EmailReceivedItemImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(14,17);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// noPortraitThumb
	this.noPortraitThumb = new lib.NoPortraitThumb();
	this.noPortraitThumb.name = "noPortraitThumb";
	this.noPortraitThumb.setTransform(14,17);

	this.timeline.addTween(cjs.Tween.get(this.noPortraitThumb).wait(1));

	// bg
	this.background = new lib.EmailReceivedItemBackground();
	this.background.name = "background";

	this.timeline.addTween(cjs.Tween.get(this.background).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailReceivedItemSkin, new cjs.Rectangle(0,0,1024,370), null);


(lib.EmailDraftItemSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// contentContainer
	this.contentContainer = new lib.ContentContainer();
	this.contentContainer.name = "contentContainer";
	this.contentContainer.setTransform(46,16);

	this.timeline.addTween(cjs.Tween.get(this.contentContainer).wait(1));

	// replyIcon
	this.replyIcon = new lib.ReplyIcon_1();
	this.replyIcon.name = "replyIcon";
	this.replyIcon.setTransform(26,33.5,1,1,0,0,0,12,14.5);

	this.timeline.addTween(cjs.Tween.get(this.replyIcon).wait(1));

	// bg
	this.instance = new lib.DraftBG();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftItemSkin, new cjs.Rectangle(0,0,1082,323.5), null);


(lib.EmailDraftInputButtonUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibhhii", "20px 'Arial'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 28;
	this.textfield.lineWidth = 793;
	this.textfield.parent = this;
	this.textfield.setTransform(2,16);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.EditIconUp_1();
	this.icon.name = "icon";
	this.icon.setTransform(809,41);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// bitmap
	this.instance = new lib.LaptopChoiceButtonUp();
	this.instance.setTransform(-18,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputButtonUp, new cjs.Rectangle(-18,0,857,74), null);


(lib.EmailDraftInputButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibhhii", "20px 'Arial'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 28;
	this.textfield.lineWidth = 793;
	this.textfield.parent = this;
	this.textfield.setTransform(2,16);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.EditIconUp_1();
	this.icon.name = "icon";
	this.icon.setTransform(809,41);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// bitmap
	this.instance = new lib.LaptopChoiceButtonUp();
	this.instance.setTransform(-18,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputButtonOver, new cjs.Rectangle(-18,0,857,74), null);


(lib.EmailDraftInputButtonDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibhhii", "20px 'Arial'", "#333333");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 28;
	this.textfield.lineWidth = 793;
	this.textfield.parent = this;
	this.textfield.setTransform(2,16);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.EditIconUp_1();
	this.icon.name = "icon";
	this.icon.setTransform(809,41);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// bitmap
	this.instance = new lib.LaptopChoiceButtonHi();
	this.instance.setTransform(-18,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputButtonDown, new cjs.Rectangle(-18,0,857,74), null);


(lib.EmailDraftInputButtonDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibhhii", "20px 'Arial'", "#AAD2E3");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 28;
	this.textfield.lineWidth = 793;
	this.textfield.parent = this;
	this.textfield.setTransform(2,16);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// icon
	this.icon = new lib.EditIconDisabeld();
	this.icon.name = "icon";
	this.icon.setTransform(809,41);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// bitmap
	this.instance = new lib.LaptopChoiceButtonDisabled();
	this.instance.setTransform(-18,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputButtonDisabled, new cjs.Rectangle(-18,0,857,74), null);


(lib.EmailDraftInputSelectionComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// up
	this.upLabelTextField = new cjs.Text("Pick an answer", "20px 'Arial'", "#333333");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 28;
	this.upLabelTextField.lineWidth = 692;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(23.2,13.1);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// over
	this.overLabelTextField = new cjs.Text("Pick an answer", "20px 'Arial'", "#333333");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 28;
	this.overLabelTextField.lineWidth = 660;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(23.2,13.1);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// down
	this.downLabelTextField = new cjs.Text("Pick an answer", "20px 'Arial'", "#333333");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 28;
	this.downLabelTextField.lineWidth = 688;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(23.2,13.1);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// disabled
	this.disabledLabelTextField = new cjs.Text("Pick an answer", "20px 'Arial'", "#333333");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 28;
	this.disabledLabelTextField.lineWidth = 693;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(23.2,13.1);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// icon
	this.icon = new lib.DropDownIcon();
	this.icon.name = "icon";
	this.icon.setTransform(839.65,29);
	var iconFilter_1 = new cjs.ColorFilter(1,1,1,1,0,0,0,0);
	this.icon.filters = [iconFilter_1];
	this.icon.cache(-15,-9,30,17);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(2).to({y:26},0).wait(2));
	this.timeline.addTween(cjs.Tween.get(iconFilter_1).wait(3).to(new cjs.ColorFilter(0,0,0,1,85,164,200,0), 0).wait(1));

	// Layer_1
	this.instance = new lib.LaptopEmailOptionButton();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.icon, startFrame:2, endFrame:2, x:-15, y:-9, w:30, h:17});
	this.filterCacheList.push({instance: this.icon, startFrame:3, endFrame:3, x:-15, y:-9, w:30, h:17});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,884,54);


(lib.EmailConversationListItemSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"new":0,"opened":1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// imageContainer
	this.imageContainer = new lib.EmailReceivedItemImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(35,14.4);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(2));

	// noPortraitThumb
	this.noPortraitThumb = new lib.NoPortraitThumb();
	this.noPortraitThumb.name = "noPortraitThumb";
	this.noPortraitThumb.setTransform(35,14.4);

	this.timeline.addTween(cjs.Tween.get(this.noPortraitThumb).wait(2));

	// textFields
	this.subjectTextField = new cjs.Text("Meeting Lorem Ipsum", "bold 20px 'Open Sans'", "#333333");
	this.subjectTextField.name = "subjectTextField";
	this.subjectTextField.lineHeight = 29;
	this.subjectTextField.lineWidth = 813;
	this.subjectTextField.parent = this;
	this.subjectTextField.setTransform(135.25,56.7);
ranj.TextOffsetFixer.fix(this.subjectTextField);

	this.nameTextField = new cjs.Text("John Doe", "bold 20px 'Open Sans'", "#55A4C8");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 29;
	this.nameTextField.lineWidth = 812;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(135.25,22.75);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nameTextField,p:{font:"bold 20px 'Open Sans'"}},{t:this.subjectTextField,p:{font:"bold 20px 'Open Sans'"}}]}).to({state:[{t:this.nameTextField,p:{font:"20px 'Open Sans'"}},{t:this.subjectTextField,p:{font:"20px 'Open Sans'"}}]},1).wait(1));

	// button
	this.button = new lib.EmptyListButton();
	this.button.name = "button";

	this.timeline.addTween(cjs.Tween.get(this.button).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1036,106);


(lib.ChatContactItem = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// newIndicator
	this.newIndicator = new lib.NewIndicator();
	this.newIndicator.name = "newIndicator";
	this.newIndicator.setTransform(361.75,32.75);

	this.timeline.addTween(cjs.Tween.get(this.newIndicator).wait(1));

	// statusTextField
	this.titleTextField = new cjs.Text("[Title]", "15px 'Arial'", "#EBEAEA");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 19;
	this.titleTextField.lineWidth = 226;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(93.5,23.85);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.timeline.addTween(cjs.Tween.get(this.titleTextField).wait(1));

	// titleTextField
	this.statusTextField = new cjs.Text("[Status]", "15px 'Arial'", "#EBEAEA");
	this.statusTextField.name = "statusTextField";
	this.statusTextField.lineHeight = 19;
	this.statusTextField.lineWidth = 226;
	this.statusTextField.parent = this;
	this.statusTextField.setTransform(93.5,44.2);
ranj.TextOffsetFixer.fix(this.statusTextField);

	this.timeline.addTween(cjs.Tween.get(this.statusTextField).wait(1));

	// nameTextField
	this.nameTextField = new cjs.Text("[Name]", "bold 15px 'Open Sans'", "#55A4C8");
	this.nameTextField.name = "nameTextField";
	this.nameTextField.lineHeight = 22;
	this.nameTextField.lineWidth = 246;
	this.nameTextField.parent = this;
	this.nameTextField.setTransform(93.5,3.5);
ranj.TextOffsetFixer.fix(this.nameTextField);

	this.timeline.addTween(cjs.Tween.get(this.nameTextField).wait(1));

	// imageContainer
	this.imageContainer = new lib.ImageContainer();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(13,0);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// noPortraitThumb
	this.noPortraitThumb = new lib.NoPortraitThumbSmall();
	this.noPortraitThumb.name = "noPortraitThumb";
	this.noPortraitThumb.setTransform(13,0);

	this.timeline.addTween(cjs.Tween.get(this.noPortraitThumb).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ChatContactItem, new cjs.Rectangle(13,0,362.8,68), null);


(lib.LaptopEmailIndicatorButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// emailIcon
	this.icon = new lib.EmailIcon();
	this.icon.name = "icon";
	this.icon.setTransform(9,10);

	this.timeline.addTween(cjs.Tween.get(this.icon).wait(1));

	// textFields
	this.subjectTextField = new cjs.Text("Email Body text", "12px 'Arial'", "#FFFFFF");
	this.subjectTextField.name = "subjectTextField";
	this.subjectTextField.lineHeight = 15;
	this.subjectTextField.lineWidth = 185;
	this.subjectTextField.parent = this;
	this.subjectTextField.setTransform(36,16.35);
ranj.TextOffsetFixer.fix(this.subjectTextField);

	this.senderTextField = new cjs.Text("Wethouder Sjakie", "12px 'Arial'", "#FFFFFF");
	this.senderTextField.name = "senderTextField";
	this.senderTextField.lineHeight = 15;
	this.senderTextField.lineWidth = 185;
	this.senderTextField.parent = this;
	this.senderTextField.setTransform(36,2.35);
ranj.TextOffsetFixer.fix(this.senderTextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.senderTextField},{t:this.subjectTextField}]}).wait(1));

	// bg
	this.button = new lib.IndicatorBackgroundButton();
	this.button.name = "button";
	this.button.setTransform(113.5,17.65,1,1.4583,0,0,0,113.5,12.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailIndicatorButton, new cjs.Rectangle(0,0,227,35), null);


(lib.LaptopEmailDraftButton9SliceUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// back
	this.backArrow = new lib.SmallBackButtonBase();
	this.backArrow.name = "backArrow";
	this.backArrow.setTransform(-390.4,0);
	var backArrowFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.backArrow.filters = [backArrowFilter_1];
	this.backArrow.cache(-11,-13,22,25);

	this.timeline.addTween(cjs.Tween.get(this.backArrow).wait(1));
	this.timeline.addTween(cjs.Tween.get(backArrowFilter_1).wait(1));

	// vinkje
	this.checkmark = new lib.vinkjeIconBase();
	this.checkmark.name = "checkmark";
	this.checkmark.setTransform(-390.5,0);

	this.timeline.addTween(cjs.Tween.get(this.checkmark).wait(1));

	// icon
	this.textfield = new cjs.Text("iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "20px 'Arial'", "#534741");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 28;
	this.textfield.lineWidth = 710;
	this.textfield.parent = this;
	this.textfield.setTransform(-350,-13.45);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.LaptopModalButonUp();
	this.instance.setTransform(-442.5,-27.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailDraftButton9SliceUp, new cjs.Rectangle(-442.5,-27.5,885,55), null);


(lib.LaptopEmailDraftButton9SliceOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// back
	this.backArrow = new lib.SmallBackButtonBase();
	this.backArrow.name = "backArrow";
	this.backArrow.setTransform(-390.4,0);
	var backArrowFilter_1 = new cjs.ColorFilter(0,0,0,1,83,71,65,0);
	this.backArrow.filters = [backArrowFilter_1];
	this.backArrow.cache(-11,-13,22,25);

	this.timeline.addTween(cjs.Tween.get(this.backArrow).wait(1));
	this.timeline.addTween(cjs.Tween.get(backArrowFilter_1).wait(1));

	// vinkje
	this.checkmark = new lib.vinkjeIconBase();
	this.checkmark.name = "checkmark";
	this.checkmark.setTransform(-390.5,0);

	this.timeline.addTween(cjs.Tween.get(this.checkmark).wait(1));

	// icon
	this.textfield = new cjs.Text("iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "20px 'Arial'", "#534741");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 28;
	this.textfield.lineWidth = 710;
	this.textfield.parent = this;
	this.textfield.setTransform(-350,-13.45);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.LaptopModalButonUp();
	this.instance.setTransform(-442.5,-27.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailDraftButton9SliceOver, new cjs.Rectangle(-442.5,-27.5,885,55), null);


(lib.LaptopEmailDraftButton9SliceDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// back
	this.backArrow = new lib.SmallBackButtonBaseWhite();
	this.backArrow.name = "backArrow";
	this.backArrow.setTransform(-390.4,0);

	this.timeline.addTween(cjs.Tween.get(this.backArrow).wait(1));

	// vinkje
	this.checkmark = new lib.vinkjeIconBaseWhite();
	this.checkmark.name = "checkmark";
	this.checkmark.setTransform(-390.5,0);

	this.timeline.addTween(cjs.Tween.get(this.checkmark).wait(1));

	// icon
	this.textfield = new cjs.Text("iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "20px 'Arial'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 28;
	this.textfield.lineWidth = 710;
	this.textfield.parent = this;
	this.textfield.setTransform(-350,-13.45);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.LaptopModalButtonHipngcopy();
	this.instance.setTransform(-443,-28);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailDraftButton9SliceDown, new cjs.Rectangle(-443,-28,885,55), null);


(lib.LaptopEmailDraftButton9SliceDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// back
	this.backArrow = new lib.SmallBackButtonBase();
	this.backArrow.name = "backArrow";
	this.backArrow.setTransform(-390.4,0);
	this.backArrow.alpha = 0.3008;

	this.timeline.addTween(cjs.Tween.get(this.backArrow).wait(1));

	// vinkje
	this.checkmark = new lib.vinkjeIconBase();
	this.checkmark.name = "checkmark";
	this.checkmark.setTransform(-390.5,0);
	this.checkmark.alpha = 0.3008;

	this.timeline.addTween(cjs.Tween.get(this.checkmark).wait(1));

	// icon
	this.textfield = new cjs.Text("iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "20px 'Arial'", "#EBEAEA");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 28;
	this.textfield.lineWidth = 710;
	this.textfield.parent = this;
	this.textfield.setTransform(-350,-13.45);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.LaptopModalButonUp();
	this.instance.setTransform(-442.5,-27.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailDraftButton9SliceDisabled, new cjs.Rectangle(-442.5,-27.5,885,55), null);


(lib.LaptopMainScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// closeButton
	this.closeButton = new lib.CloseButtonBase();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(655.75,-358.7);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// fileButton
	this.fileButton = new lib.FileButton();
	this.fileButton.name = "fileButton";
	this.fileButton.setTransform(67,-238);

	this.timeline.addTween(cjs.Tween.get(this.fileButton).wait(1));

	// emailButton
	this.emailButton = new lib.EmailButton();
	this.emailButton.name = "emailButton";
	this.emailButton.setTransform(-78,-238);

	this.timeline.addTween(cjs.Tween.get(this.emailButton).wait(1));

	// desktop_image
	this.instance = new lib.LaptopDesktop();
	this.instance.setTransform(-701,-401);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopMainScreenSkin, new cjs.Rectangle(-701,-401,1403,802), null);


(lib.LaptopEmailContentScrollView = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// emptyIndicationTextField
	this.emptyIndicationTextField = new cjs.Text("There are no conversations in this box.", "20px 'Arial'", "#1E1E28");
	this.emptyIndicationTextField.name = "emptyIndicationTextField";
	this.emptyIndicationTextField.textAlign = "center";
	this.emptyIndicationTextField.lineHeight = 24;
	this.emptyIndicationTextField.lineWidth = 943;
	this.emptyIndicationTextField.parent = this;
	this.emptyIndicationTextField.setTransform(511.25,21.25);
ranj.TextOffsetFixer.fix(this.emptyIndicationTextField);

	this.timeline.addTween(cjs.Tween.get(this.emptyIndicationTextField).wait(1));

	// scrollbar
	this.vScrollBar = new lib.LaptopEmailScrollBar();
	this.vScrollBar.name = "vScrollBar";
	this.vScrollBar.setTransform(1021.95,0);

	this.timeline.addTween(cjs.Tween.get(this.vScrollBar).wait(1));

	// contentContainer
	this.contentContainer = new lib.ContentContainer();
	this.contentContainer.name = "contentContainer";
	this.contentContainer.setTransform(0.5,0.5,1,1,0,0,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.contentContainer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailContentScrollView, new cjs.Rectangle(-0.5,-0.5,1034.4,713.5), null);


(lib.LaptopDeviceSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// closeButton
	this.closeButton = new lib.SmartphoneCloseButton_1();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(0,464);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// screenDimensions
	this.screenCanvas = new lib.LaptopDimensions();
	this.screenCanvas.name = "screenCanvas";
	this.screenCanvas.setTransform(0,17.15,1,0.9877);

	this.timeline.addTween(cjs.Tween.get(this.screenCanvas).wait(1));

	// laptopFrame
	this.phoneFrame = new lib.LaptopFrame();
	this.phoneFrame.name = "phoneFrame";

	this.timeline.addTween(cjs.Tween.get(this.phoneFrame).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopDeviceSkin, new cjs.Rectangle(-961,-541,1939,1082), null);


(lib.FileViewerSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// loadingIndicator
	this.loadingIndicator = new lib.LoadingIndicator();
	this.loadingIndicator.name = "loadingIndicator";
	this.loadingIndicator.setTransform(-2,40);

	this.timeline.addTween(cjs.Tween.get(this.loadingIndicator).wait(1));

	// scrollBar
	this.scrollBar = new lib.FileExplorerViewerScrollBar();
	this.scrollBar.name = "scrollBar";
	this.scrollBar.setTransform(670,-250);

	this.timeline.addTween(cjs.Tween.get(this.scrollBar).wait(1));

	// scrollPane
	this.scrollPane = new lib.FileExplorerViewerScrollPane();
	this.scrollPane.name = "scrollPane";
	this.scrollPane.setTransform(-718,-250.5,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.scrollPane).wait(1));

	// texts
	this.title = new cjs.Text("Document title", "30px 'Arial'", "#67666F");
	this.title.name = "title";
	this.title.lineHeight = 34;
	this.title.lineWidth = 662;
	this.title.parent = this;
	this.title.setTransform(-643.85,-356.5);
ranj.TextOffsetFixer.fix(this.title);

	this.timeline.addTween(cjs.Tween.get(this.title).wait(1));

	// panel
	this.instance = new lib.FileExplorerBG();
	this.instance.setTransform(-68,40);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileViewerSkin, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.FileExplorerSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// noFilesTextField
	this.noFilesTextField = new cjs.Text("This directory is empty", "18px 'Arial'", "#67666F");
	this.noFilesTextField.name = "noFilesTextField";
	this.noFilesTextField.textAlign = "center";
	this.noFilesTextField.lineHeight = 20;
	this.noFilesTextField.lineWidth = 472;
	this.noFilesTextField.parent = this;
	this.noFilesTextField.setTransform(-18,-184.65);
ranj.TextOffsetFixer.fix(this.noFilesTextField);

	this.timeline.addTween(cjs.Tween.get(this.noFilesTextField).wait(1));

	// scrollBar
	this.scrollBar = new lib.FileExplorerAppScrollBar();
	this.scrollBar.name = "scrollBar";
	this.scrollBar.setTransform(670,-206);

	this.timeline.addTween(cjs.Tween.get(this.scrollBar).wait(1));

	// scrollPane
	this.scrollPane = new lib.FileExplorerAppScrollPane();
	this.scrollPane.name = "scrollPane";
	this.scrollPane.setTransform(-718,-206);

	this.timeline.addTween(cjs.Tween.get(this.scrollPane).wait(1));

	// backButton
	this.backButton = new lib.TopBarBackButton();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-678.5,-335.5);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// texts
	this.titleTextField = new cjs.Text("File Explorer", "30px 'Arial'", "#67666F");
	this.titleTextField.name = "titleTextField";
	this.titleTextField.lineHeight = 34;
	this.titleTextField.lineWidth = 193;
	this.titleTextField.parent = this;
	this.titleTextField.setTransform(-643.85,-355.5);
ranj.TextOffsetFixer.fix(this.titleTextField);

	this.pathTextField = new cjs.Text("All Files", "18px 'Arial'", "#A2A2A2");
	this.pathTextField.name = "pathTextField";
	this.pathTextField.lineHeight = 20;
	this.pathTextField.lineWidth = 1259;
	this.pathTextField.parent = this;
	this.pathTextField.setTransform(-643.85,-296.3);
ranj.TextOffsetFixer.fix(this.pathTextField);

	this.columnHeader1TextField = new cjs.Text("Name", "18px 'Arial'", "#67666F");
	this.columnHeader1TextField.name = "columnHeader1TextField";
	this.columnHeader1TextField.lineHeight = 20;
	this.columnHeader1TextField.lineWidth = 104;
	this.columnHeader1TextField.parent = this;
	this.columnHeader1TextField.setTransform(-588.1,-232.1);
ranj.TextOffsetFixer.fix(this.columnHeader1TextField);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.columnHeader1TextField},{t:this.pathTextField},{t:this.titleTextField}]}).wait(1));

	// panel
	this.instance = new lib.FileExplorerBG();
	this.instance.setTransform(-68,41);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FileExplorerSkin, new cjs.Rectangle(-718.5,-384,1400.8,800), null);


(lib.EmailDraftOptionOverlayOptionButtonSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabled
	this.disabled = new lib.LaptopEmailDraftButton9SliceDisabled();
	this.disabled.name = "disabled";

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(1));

	// down
	this.down = new lib.LaptopEmailDraftButton9SliceDown();
	this.down.name = "down";
	this.down.setTransform(0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.down).wait(1));

	// over
	this.over = new lib.LaptopEmailDraftButton9SliceOver();
	this.over.name = "over";

	this.timeline.addTween(cjs.Tween.get(this.over).wait(1));
	this.over.addEventListener("tick", AdobeAn.handleFilterCache);

	// up
	this.up = new lib.LaptopEmailDraftButton9SliceUp();
	this.up.name = "up";

	this.timeline.addTween(cjs.Tween.get(this.up).wait(1));
	this.up.addEventListener("tick", AdobeAn.handleFilterCache);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftOptionOverlayOptionButtonSkin, new cjs.Rectangle(-442.5,-27.5,885,55), null);


(lib.EmailBoxSelectionComponent = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// blurOverlay
	this.blurOverlay = new lib.EmailBoxSelectionBlurOverlay();
	this.blurOverlay.name = "blurOverlay";
	this.blurOverlay.setTransform(178,356.5);

	this.timeline.addTween(cjs.Tween.get(this.blurOverlay).wait(1));

	// buttons
	this.outboxButton = new lib.SentButton();
	this.outboxButton.name = "outboxButton";
	this.outboxButton.setTransform(198,158.5);

	this.draftsButton = new lib.DraftsButton();
	this.draftsButton.name = "draftsButton";
	this.draftsButton.setTransform(198,91.5);

	this.inboxButton = new lib.EmailBoxButton();
	this.inboxButton.name = "inboxButton";
	this.inboxButton.setTransform(198,25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.inboxButton},{t:this.draftsButton},{t:this.outboxButton}]}).wait(1));

	// bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#55A4C8").s().p("EgbzA3tMAAAhvZMA3nAAAMAAABvZg");
	this.shape.setTransform(178,356.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailBoxSelectionComponent, new cjs.Rectangle(-0.5,-0.5,357,714), null);


(lib.EmailDraftInputComponentSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// up
	this.up = new lib.EmailDraftInputButtonUp();
	this.up.name = "up";
	this.up.setTransform(166.5,57,1,1,0,0,0,166.5,57);

	this.timeline.addTween(cjs.Tween.get(this.up).wait(1));

	// over
	this.over = new lib.EmailDraftInputButtonOver();
	this.over.name = "over";
	this.over.setTransform(166.5,57,1,1,0,0,0,166.5,57);

	this.timeline.addTween(cjs.Tween.get(this.over).wait(1));

	// down
	this.down = new lib.EmailDraftInputButtonDown();
	this.down.name = "down";
	this.down.setTransform(166.5,57,1,1,0,0,0,166.5,57);

	this.timeline.addTween(cjs.Tween.get(this.down).wait(1));

	// disabled
	this.disabled = new lib.EmailDraftInputButtonDisabled();
	this.disabled.name = "disabled";

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EmailDraftInputComponentSkin, new cjs.Rectangle(-18,0,857,74), null);


(lib.LaptopFileViewerScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// backButton
	this.backButton = new lib.TopBarBackButton();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-660.5,-352);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// closeButton
	this.NewKeyDecisionFound = new lib.NewKeyDecisionFound();
	this.NewKeyDecisionFound.name = "NewKeyDecisionFound";
	this.NewKeyDecisionFound.setTransform(-34.05,-26.35);

	this.closeButton = new lib.TopBarCloseWindowButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(656,-360);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.closeButton},{t:this.NewKeyDecisionFound}]}).wait(1));

	// fileViewer
	this.fileViewer = new lib.FileViewerSkin();
	this.fileViewer.name = "fileViewer";
	this.fileViewer.setTransform(17.8,-15,1,1,0,0,0,-0.2,0);

	this.timeline.addTween(cjs.Tween.get(this.fileViewer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopFileViewerScreenSkin, new cjs.Rectangle(-700.5,-400,1400.5,800), null);


(lib.LaptopFileExplorerScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// closeButton
	this.closeButton = new lib.TopBarCloseWindowButton();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(645,-350);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));

	// fileExplorer
	this.fileExplorer = new lib.FileExplorerSkin();
	this.fileExplorer.name = "fileExplorer";
	this.fileExplorer.setTransform(18,-16);

	this.timeline.addTween(cjs.Tween.get(this.fileExplorer).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopFileExplorerScreenSkin, new cjs.Rectangle(-700.5,-400,1400.8,800), null);


(lib.LaptopEmailScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// KDdiscoveryanimation
	this.NewKeyDecisionFound = new lib.NewKeyDecisionFound();
	this.NewKeyDecisionFound.name = "NewKeyDecisionFound";
	this.NewKeyDecisionFound.setTransform(-34.05,-26.35);

	this.timeline.addTween(cjs.Tween.get(this.NewKeyDecisionFound).wait(1));

	// boxButtons
	this.boxButtons = new lib.EmailBoxSelectionComponent();
	this.boxButtons.name = "boxButtons";
	this.boxButtons.setTransform(-502,-229,1,1,0,0,0,198,84);

	this.timeline.addTween(cjs.Tween.get(this.boxButtons).wait(1));

	// applicationTitleTextField
	this.applicationTitleTextField = new cjs.Text("Mailboxes", "30px 'Arial'", "#67666F");
	this.applicationTitleTextField.name = "applicationTitleTextField";
	this.applicationTitleTextField.lineHeight = 36;
	this.applicationTitleTextField.lineWidth = 297;
	this.applicationTitleTextField.parent = this;
	this.applicationTitleTextField.setTransform(-622.5,-382.45);
ranj.TextOffsetFixer.fix(this.applicationTitleTextField);

	this.timeline.addTween(cjs.Tween.get(this.applicationTitleTextField).wait(1));

	// topBarIcon
	this.instance = new lib.LaptopMailIcon();
	this.instance.setTransform(-677,-373);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// topBarNavButtons
	this.closeButton = new lib.TopBarCloseWindowButton_1();
	this.closeButton.name = "closeButton";
	this.closeButton.setTransform(656,-360);

	this.timeline.addTween(cjs.Tween.get(this.closeButton).wait(1));
	this.closeButton.addEventListener("tick", AdobeAn.handleFilterCache);

	// backButton
	this.backButton = new lib.TopBarBackButton();
	this.backButton.name = "backButton";
	this.backButton.setTransform(-312,-360);

	this.timeline.addTween(cjs.Tween.get(this.backButton).wait(1));

	// conversation
	this.conversation = new lib.LaptopEmailContentScrollView();
	this.conversation.name = "conversation";
	this.conversation.setTransform(-334,-313);

	this.timeline.addTween(cjs.Tween.get(this.conversation).wait(1));

	// conversationList
	this.conversationList = new lib.LaptopEmailContentScrollView();
	this.conversationList.name = "conversationList";
	this.conversationList.setTransform(-334,-313);

	this.timeline.addTween(cjs.Tween.get(this.conversationList).wait(1));

	// bg
	this.instance_1 = new lib.LaptopEmailClientBG();
	this.instance_1.setTransform(-50,25);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LaptopEmailScreenSkin, new cjs.Rectangle(-700.5,-400,1400.5,857.6), null);


// stage content:
(lib.LaptopAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);
// library properties:
lib.properties = {
	id: 'CF364FABBE3675439F965DE3116F7378',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#666666",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/LaptopAssets/ActiveKD.png", id:"LaptopAssets_ActiveKD", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/BackButtonDisabled.png", id:"LaptopAssets_BackButtonDisabled", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/BackButtonHi.png", id:"LaptopAssets_BackButtonHi", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/BackButtonUp.png", id:"LaptopAssets_BackButtonUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/ChatIcon.png", id:"LaptopAssets_ChatIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/ChatNPCBalloon2.png", id:"LaptopAssets_ChatNPCBalloon2", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/ChoiceIndicator111.png", id:"LaptopAssets_ChoiceIndicator111", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/CloseButtonDisabled.png", id:"LaptopAssets_CloseButtonDisabled", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/CloseButtonHi.png", id:"LaptopAssets_CloseButtonHi", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/CloseButtonIcon.png", id:"LaptopAssets_CloseButtonIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/CloseButtonUp.png", id:"LaptopAssets_CloseButtonUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/DraftBG.png", id:"LaptopAssets_DraftBG", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/EditIconDisabled.png", id:"LaptopAssets_EditIconDisabled", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/EditIconUp.png", id:"LaptopAssets_EditIconUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/EmailReceivedBackground.png", id:"LaptopAssets_EmailReceivedBackground", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/EmptyThumb.png", id:"LaptopAssets_EmptyThumb", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/EmptyThumbBig.png", id:"LaptopAssets_EmptyThumbBig", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/FileExplorerNew.png", id:"LaptopAssets_FileExplorerNew", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/FolderIconUp.png", id:"LaptopAssets_FolderIconUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/GroupChatNPCBalloon2.png", id:"LaptopAssets_GroupChatNPCBalloon2", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/ImageIconUp.png", id:"LaptopAssets_ImageIconUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopBackArrow.png", id:"LaptopAssets_LaptopBackArrow", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopBackArrowWhite.png", id:"LaptopAssets_LaptopBackArrowWhite", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopChoiceButtonDisabled.png", id:"LaptopAssets_LaptopChoiceButtonDisabled", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopChoiceButtonHi.png", id:"LaptopAssets_LaptopChoiceButtonHi", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopChoiceButtonUp.png", id:"LaptopAssets_LaptopChoiceButtonUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopDesktop.png", id:"LaptopAssets_LaptopDesktop", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopDraftCounterIcon.png", id:"LaptopAssets_LaptopDraftCounterIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopDraftIcon.png", id:"LaptopAssets_LaptopDraftIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopDropDownArrow.png", id:"LaptopAssets_LaptopDropDownArrow", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopEmailIndicatorButtonBackground.png", id:"LaptopAssets_LaptopEmailIndicatorButtonBackground", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopEmailOptionButton.png", id:"LaptopAssets_LaptopEmailOptionButton", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopFolderNotification.png", id:"LaptopAssets_LaptopFolderNotification", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopInboxIcon.png", id:"LaptopAssets_LaptopInboxIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopMailIcon.png", id:"LaptopAssets_LaptopMailIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopModalButonUp.png", id:"LaptopAssets_LaptopModalButonUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopModalButtonHipngcopy.png", id:"LaptopAssets_LaptopModalButtonHipngcopy", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopSentButtonDisabled.png", id:"LaptopAssets_LaptopSentButtonDisabled", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopSentButtonHi.png", id:"LaptopAssets_LaptopSentButtonHi", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopSentButtonUp.png", id:"LaptopAssets_LaptopSentButtonUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopSentIcon.png", id:"LaptopAssets_LaptopSentIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopSkinBG.png", id:"LaptopAssets_LaptopSkinBG", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopVinkje.png", id:"LaptopAssets_LaptopVinkje", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/LaptopVinkjeWhite.png", id:"LaptopAssets_LaptopVinkjeWhite", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/MailIcon.png", id:"LaptopAssets_MailIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/NewIndicatorLarge.png", id:"LaptopAssets_NewIndicatorLarge", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/PdfIconUp.png", id:"LaptopAssets_PdfIconUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/PowerpointIconUp.png", id:"LaptopAssets_PowerpointIconUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/RedPill.png", id:"LaptopAssets_RedPill", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/ReplyIcon.png", id:"LaptopAssets_ReplyIcon", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/SmartphoneCloseButton.png", id:"LaptopAssets_SmartphoneCloseButton", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/Spinner.png", id:"LaptopAssets_Spinner", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/SpinnerPanel.png", id:"LaptopAssets_SpinnerPanel", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/SpreadsheetIconUp.png", id:"LaptopAssets_SpreadsheetIconUp", bundle:"LaptopAssets"},
		{src:"assets/skins/images/LaptopAssets/WordIconUp.png", id:"LaptopAssets_WordIconUp", bundle:"LaptopAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.LaptopAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.LaptopAssets;